import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { toNotifiableError } from 'pdfsnake-commonui/classes/BugsnagHelpers';
import { snakeI18n } from 'pdfsnake-commonui/main';
import { useCurrentUser } from 'pdfsnake-commonui/classes/CommonGlobals';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { VueRouterRoutingProvider } from '@bugsnag/vue-router-performance';

// Lots of try..catches because the app must start even if bugsnag fails
// for any reason.


let bugsnagStarted = false;
try {
    Bugsnag.start({
        apiKey: 'fba9f5d88ca92acbae72b40251ac604f',
        plugins: [new BugsnagPluginVue()],
        appVersion: import.meta.env.VITE_PDF_SNAKE_VERSION,
        onError: function(event) {
            if (!import.meta.env.PROD) {
                return false;
            }
            const uid = useCurrentUser().id;
            if (uid) {
                event.setUser(uid);
            }
            event.addMetadata('Distribution', {
                distribution: 'Web'
            })
        }
    })
    bugsnagStarted = true;
} catch (e) {
    console.error("while starting bugsnag", e);
}


try {
    BugsnagPerformance.start({
        apiKey: 'fba9f5d88ca92acbae72b40251ac604f',
        appVersion: import.meta.env.VITE_PDF_SNAKE_VERSION,
        releaseStage: import.meta.env.MODE,
        routingProvider: new VueRouterRoutingProvider(router, '/')
    })
} catch (e) {
    console.error("while starting bugsnag performance", e);
    if (bugsnagStarted) {
        Bugsnag.notify(toNotifiableError(e), (event) => {
            event.severity = "error";
            event.addMetadata("location", { href: window.location.href });
        });

    }
}

const app = createApp(App).use(createPinia()).use(router).use(snakeI18n);

try {
    const bugsnagVue = Bugsnag.getPlugin('vue');
    if (bugsnagVue) {
        app.use(bugsnagVue);
    }
} catch (e) {
    console.error("while installing bugsnag vue plug-in.");
    Bugsnag.notify(toNotifiableError(e), (event) => {
        event.severity = "error";
        event.addMetadata("location", { href: window.location.href });
    });
}

try {
    if (import.meta.env.PROD) {
        if (navigator.serviceWorker) {
            try {
                navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
            } catch (e) {
                if (bugsnagStarted) {
                    Bugsnag.notify(toNotifiableError(e), (event) => {
                        event.severity = "warning";
                        event.addMetadata("location", { href: window.location.href });
                    });
                }
            }
        }
    }
} finally {
    app.mount('#app')
}
